// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAJGvrnfQMbwW6EP4Op22Rh0BLhx8cLt2k",
  authDomain: "netflixgpt-60289.firebaseapp.com",
  projectId: "netflixgpt-60289",
  storageBucket: "netflixgpt-60289.firebasestorage.app",
  messagingSenderId: "561124306960",
  appId: "1:561124306960:web:d26afc64bdf66641989a95",
  measurementId: "G-XECF1S63QS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth();
